module.exports = __webpack_public_path__ + "static/media/tukutuku-a72c-02.b6502a58.png";